import React, { useState } from "react";
import { FaPlay, FaTimes } from "react-icons/fa";
import "./Video.css";

const Video = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsModalOpen(false);
    document.body.style.overflow = "unset";
  };

  return (
    <section id="video" className="section video-section">
      <div className="container">
        <div className="video-content">
          <div className="video-text animate-fade-in-left">
            <h2 className="video-title">Discover Our Journey</h2>
            <p className="video-description">
              Watch our introductory video to learn more about IEEE Women in
              Engineering University of Moratuwa, our mission, achievements, and
              the incredible community of women engineers we've built together.
            </p>
            <div className="video-stats">
              <div className="stat">
                <h3>150+</h3>
                <p>Active Volunteers</p>
              </div>
              <div className="stat">
                <h3>30+</h3>
                <p>Projects Completed</p>
              </div>
              <div className="stat">
                <h3>15+</h3>
                <p>Events Organized</p>
              </div>
            </div>
          </div>

          <div className="video-player animate-fade-in-right">
            <div className="video-thumbnail" onClick={openModal}>
              <img
                src="/assets/2025updated/Radiance.jpg"
                alt="IEEE WIE Introduction Video"
              />
              <div className="play-overlay">
                <button className="play-button">
                  <FaPlay />
                </button>
              </div>
              <div className="video-info">
                <span className="video-duration">5:30</span>
                <span className="video-label">Introduction Video</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className="video-modal-overlay" onClick={closeModal}>
          <div
            className="video-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="video-modal-close" onClick={closeModal}>
              <FaTimes />
            </button>

            <div className="video-container">
              {/* Replace with actual video */}
              <video
                width="100%"
                height="100%"
                controls
                autoPlay
                src="/assets/video-new.mp4"
                title="IEEE WIE Introduction Video"
              >
                Your browser does not support the video tag.
              </video>
            </div>

            <div className="video-modal-info">
              <h3>IEEE WIE University of Moratuwa - Introduction</h3>
              <p>
                Learn about our mission to empower women in engineering and
                technology. Discover our programs, achievements, and how you can
                be part of our community.
              </p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Video;
